import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { GET_SALES_SITES,GET_COMMERTIAL_LEAD_DETAILS,GET_SALES_INCENTIVE,
  GET_BENEFICIARY_SENIOR,GET_INCENTIVE_DATA,GET_FINANCE_INCENTIVE_LIST,
  ACCEPT,REJECT,GET_USER_SENIOR_INCENTIVES,UPLOAD_UTR } from "./type";

export const getSalesSites = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.getSalesIncentiveSites}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_SALES_SITES, payload: data.response.data });
    return data.response.data;
  }
};

export const getLeadCommertialDetails = (siteId) => async (dispatch) => {
    dispatch({ type: GET_COMMERTIAL_LEAD_DETAILS, payload: null });
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.getLeadCommertialDetails}?site_id=${siteId}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_COMMERTIAL_LEAD_DETAILS, payload: data.response.data });
      return data.response.data;
    }
  };

  export const saveSalesIncentive = (data) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.postSales.saveSalesIncentive
    );
    if (res?.data?.response?.status === true || res?.data?.status === 0) {
        return true;
    }
  };

  export const getAllIncentives = (page, is_specific = 0) => async (dispatch) => {
    let filter = "";
    if (is_specific == 1) {
      filter = `page=${page}&is_specific=1`;
    } else {
      filter = `page=${page}`;
    }
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.getAllIncentives}?${filter}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_SALES_INCENTIVE, payload: data.response.data });
      return data.response.data;
    }
  };

  export const getSeniorBeneficiary = (userId) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.getSeniorBeneficiary}?user_id=${userId}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_BENEFICIARY_SENIOR, payload: data.response.data });
      return data.response.data;
    }
  };

  export const getEditableData = (siteId,id) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.getEditIncentiveData}?incentive_id=${id}&site_id=${siteId}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_INCENTIVE_DATA, payload: data.response.data });
      //return data.response.data;
      return data;
    }
  }; 

  export const getIncentiveListForFinanceApproval = (page) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.getIncentiveListFinance}?page=${page}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_FINANCE_INCENTIVE_LIST, payload: data.response.data });
      return data.response.data;
    }
  };

  export const acceptApproval = (requestData) => async (dispatch) => {
    dispatch({ type: ACCEPT, payload: null });
    const res = await callWebService(
      callTypes.post,
      requestData,
      Config.postSales.acceptIncetiveApproval
    );
    if (res?.data?.response?.status === true || res?.data?.status === 0) {
      const { data } = res;
      dispatch({ type: "", payload: data.response?.data ?? data.data });
      return true;
    }
  };
  
  export const rejectApproval = (requestData) => async (dispatch) => {
    dispatch({ type: REJECT, payload: null });
    const res = await callWebService(
      callTypes.post,
      requestData,
      Config.postSales.rejectIncentiveApproval
    );
    if (res?.data?.response?.status === true || res?.data?.status === 0) {
      const { data } = res;
      dispatch({ type: "", payload: data.response?.data ?? data.data });
      return true;
    }
  };

  export const getUserSeniorIncentiveSum = (key) => async (dispatch) => {
    dispatch({ type: GET_USER_SENIOR_INCENTIVES, payload: [] });
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.getUserSeniorIncentiveLists}?key=${key}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_USER_SENIOR_INCENTIVES, payload: data.response.data });
      return data.response.data;
    }
  };

  export const uploadIncentiveUtrFile = (requestData) => async (dispatch) => {
    dispatch({ type: UPLOAD_UTR, payload: null });
    const res = await callWebService(
      callTypes.post,
      requestData,
      Config.postSales.uploadUserSeniorIncentiveUtr
    );
    if (res?.data?.response?.status === true) {
      const { data } = res;
      dispatch({ type: "", payload: data.response.data });
      return true;
    }
  };

  export const getHeadBeneficiary = (seniorId) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.getHeadBeneficiary}?senior_id=${seniorId}`
    );
    if (res) {
      const { data } = res;
      //dispatch({ type: GET_BENEFICIARY_SENIOR, payload: data.response.data });
      return data.response.data;
    }
  };

  export const getCalculatedIncentiveAmount = (siteId,incentive_for) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.getCalculatedIncentiveAmount}?site_id=${siteId}&incentive_for=${incentive_for}`
    );
    if (res) {
      const { data } = res;
      //dispatch({ type: GET_BENEFICIARY_SENIOR, payload: data.response.data });
      return data.response.data;
    }
  };
  

